import gql from 'graphql-tag';

export default gql`
  mutation claimQuoteRequest($id: ID!) {
    quoteRequest: claimQuoteRequest(id: $id) {
      id
    }
  }
`;
